define("ROOM4.CCAProductGallery.CCAProductGalleryHeader.TextSearch.View", [
  "Backbone",
  "room4_ccaproductgallery_header_text_search.tpl",
], function (Backbone, template) {
  "use strict";

  return Backbone.View.extend({
    template: template,

    events: {
      "submit [data-action='gallery-text-search']": "submitSearch",
      "click [data-action='clear-gallery-text-search']": "clearSearch",
    },

    initialize: function initialize(options) {
      var translator = options.getTranslator();

      this.getTranslator = options.getTranslator;
      this.loading = false;
      this.query = String(translator.getOptionValue("keywords") || "");
      this.feedback = "";
    },

    navigateWithQuery: function navigateWithQuery(query) {
      var translator = this.getTranslator().cloneForOptions({
        keywords: query,
        page: 1,
      });

      Backbone.history.navigate(translator.getUrl(), { trigger: true });
    },

    submitSearch: function submitSearch(event) {
      var input = this.$("[data-type='gallery-text-search-input']");
      var query = String(input.val() || "").trim();

      event.preventDefault();

      if (!query || this.loading) {
        return;
      }

      if (query.length > 200) {
        this.feedback = "Search query must not exceed 200 characters.";
        this.render();
        return;
      }

      this.query = query;
      this.loading = true;
      this.feedback = "";
      this.render();
      this.navigateWithQuery(query);
    },

    clearSearch: function clearSearch(event) {
      var translator;

      event.preventDefault();

      if (this.loading) {
        return;
      }

      translator = this.getTranslator()
        .cloneWithoutOption("keywords")
        .cloneWithoutOption("page");
      Backbone.history.navigate(translator.getUrl(), { trigger: true });
    },

    getContext: function getContext() {
      return {
        query: this.query,
        hasQuery: !!this.query,
        loading: this.loading,
        feedback: this.feedback,
      };
    },
  });
});
